import { render } from "./app.layouts.vue?vue&type=template&id=692573f8"
import script from "./app.layouts.vue?vue&type=script&lang=js"
export * from "./app.layouts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianreyes/Documents/Proyectos/buzon/buzon-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__